const enum Engine {
    "FRONTEND" = "FRONTEND",
    "BACKEND" = "BACKEND",
}

export default Engine;